import React from 'react';
import PropTypes from 'prop-types';

import { Nav, NavItem, NavLink } from 'react-bootstrap';
import Link from '../../../Link';


class StaticPageLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <>
        <Nav className='sticky-top p-3 align-items-center justify-content-between bg-white border-bottom'>
          <img src='/images/ASAP-logo.svg' className='' style={{ maxHeight: '32px' }} alt='ASAP Logo' />
          <div className='d-inline-flex'>
            <Nav.Item className='mr-2'>
              <Link to='/store/login' className={'btn btn-danger'}>Login</Link>
            </Nav.Item>
            <Nav.Item>
              <Link to='/store/signup' className={'btn btn-outline-danger'}>Register</Link>
            </Nav.Item>
          </div>
        </Nav>
        <article>
          {this.props.children}
        </article>
      </>
    );
  }
};

export default StaticPageLayout;
